import React from "react"
import { classSet, FiderContext } from "@fider/services"

import "./PoweredByFider.scss"

interface PoweredByFiderProps {
  slot: string
  className?: string
}

export const PoweredByFider = (props: PoweredByFiderProps) => {
  const fider = React.useContext(FiderContext)
  const version = fider.settings?.version?.split("-")[0]
  const versionString = fider.isSingleHostMode() && version && version !== "dev" ? `${version}` : ""

  const className = classSet({
    "c-powered": true,
    [props.className || ""]: props.className,
  })

  return (
    <div className={className}>
      <a rel="noopener" className="text-2xs" href="https://www.turium.ai/" target="_blank">
        Powered by Echo ⚡
      </a>
      {versionString && <span className="text-2xs block">{versionString}</span>}
    </div>
  )
}
